const HOST = `https://3d-api.radivas-remont.ru`;
const CONSTRUCTOR_URL = `https://3d.radivas-remont.ru`;

export {
  HOST, CONSTRUCTOR_URL
}
